<template>
  <div class="w-full bg-white border-round ss">
    <!-- <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="text-center">
        <div class="h-w-150px bg-primary mx-auto rounded-full">
          <img
            :src="showImage('Admin/Assets/Empty Cart.png')"
            alt=""
            class=""
          />
        </div>
        <span class="text-center font-semibold text-black fsize24 mb-4"
          >Your Shopping Cart is Empty!</span
        >
      </div>

      <div class="w-full justify-center pt-3 pb-6 flex">
        <vs-button
          color="primary"
          class="bg-primary px-12"
          @click="centerDialogVisible = false"
          >Continue</vs-button
        >
      </div>
    </el-dialog> -->
    <div class="">
      <!-- <div
        class="flex w-full items-start p-4 bg-f9 border-round bordb mb-10 py-4"
        v-for="(item, index) in itemstotal"
        :key="index"
      >
        <div class="w-9/12 flex gap-3 items-center">
          <img
            :src="showImage(item.image)"
            class="object-cover w-24 h-24 border-round"
            alt="banh"
          />

          <div>
            <small class="fsize10 text-6b6b6b opacity-80 font-medium"
              >Brained Studio</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ item.name }}
            </h2>
            <p
              class="font-semibold fsize10 text-dark font-medium flex items-center"
            >
              x {{ item.quantity }}
            </p>
          </div>
        </div>
        <div class="w-3/12 flex justify-end">
          <p class="text-primary fsize16 font-semibold mb-0">
            ₹{{ item.price }}
          </p>
        </div>
      </div> -->
      <!-- <div class="flex justify-between items-center pt-2">
        <small
          v-if="!isShowInput"
          class="fsize12 text-6b6b6b opacity-80 font-medium"
          >Any Details you'd like to mention?</small
        >
        <feather-icon
          @click="isShowInput = true"
          v-if="!isShowInput"
          icon="PlusIcon"
          class="cursor-pointer flex"
        />
      </div>
      <div v-if="isShowInput">
        <el-input placeholder="Enter..." type="textarea" />
        <div class="flex justify-end">
          <vs-button class="mt-2 rounded-full sm-buton flex justify-end"
            >Submit</vs-button
          >
        </div>
      </div> -->
    </div>
    <div class="mb-10" v-if="currencySymbol !== 'S$'">
      <p class="font-semibold third-fonts">Offers & Benefits</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 px-6 py-2 border-round">
        <el-collapse>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Apply Coupon Code
              </p>
            </template>
            <div v-for="(i, index) in this.allCoupons" :key="index">
              <div class="p-2 bg-f9 flex justify-between items-end">
                <!-- Consistent with real life: in line with the process and logic of
              real life, and comply with languages and habits that the users are
              used to; -->
                {{ i.couponCode }}
                <span
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                  v-if="i.usage == 'Used'"
                  >Used
                </span>
                <span
                  @click="selectedCoupon(i)"
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                  v-else-if="couponSelected.couponCode != i.couponCode"
                  >Apply
                </span>
                <span
                  @click="removeCoupon(i)"
                  variant="primary"
                  class="text-primary font-semibold sm-fsize6 underline"
                  v-else-if="couponSelected.couponCode === i.couponCode"
                  >Remove
                </span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="mb-8">
      <p class="font-semibold third-fonts">Bill Summary</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 py-4 px-6 border-round">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Items Total(<span>{{ itemstotal.length }}</span
                >)
              </p>
            </template>
            <div class="flex justify-between items-end">
              <div>
                <h2
                  class="text-dark fsize14 font-semibold mb-2 mt-1"
                  v-for="(item, index) in itemstotal"
                  :key="index"
                >
                  {{ item.name + "  x" + item.quantity }}
                </h2>
              </div>
              <div class="mt-1" v-if="currencySymbol !== 'S$'">
                <p
                  class="col-4f fsize12 opacity-80 font-semibold mb-2"
                  v-for="(item, index) in itemstotal"
                  :key="index"
                >
                  {{ cardoptions[0].currency
                  }}{{
                    item.price === "Free"
                      ? 0 * item.quantity
                      : item.price * item.quantity
                  }}
                </p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div
          class="flex justify-between items-end"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Taxes & Charges</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ gstNumber }}% GST
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              +{{ cardoptions[0].currency }}{{ calculation.gst }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-end bordb pb-2"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Promo Code</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ this.couponSelected.couponCode }}
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold opacity-80">
              -{{ cardoptions[0].currency }}{{ this.discountRs }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-center"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <h2 class="text-dark fsize14 font-semibold">Total Amount</h2>
          </div>
          <div class="">
            <!-- <p class="col-4f fsize14 font-semibold">
              ₹{{ this.discountRs != 0 ? calculation.total : this.withGst }}
            </p> -->
            <p class="col-4f fsize14 font-semibold">
              {{ cardoptions[0].currency
              }}{{
                this.isCouponSelected
                  ? this.afterDiscountAmt
                  : calculation.total
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between w-full mt-8 px-2 items-center">
      <div v-if="currencySymbol !== 'S$'">
        <small class="col-4f fsize14 font-semibold fsize12">
          {{ cardoptions[0].currency
          }}{{
            this.isCouponSelected ? this.afterDiscountAmt : calculation.total
          }}
        </small>
        <h2 class="text-primary fsize16 font-semibold">Bill Summary</h2>
      </div>
      <div class="">
        <vs-button
          @click="
            () => {
              if (currencySymbol === 'S$') {
                SGMailTriggregd();
              } else {
                orderConfirm();
              }
            }
          "
          variant="primary"
          class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
          :disabled="this.itemstotal.length === 0"
        >
          {{ currencySymbol === "S$" ? "Get Quote" : " Proceed to pay" }}
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      activeName: "",
      isCouponSelected: false,
      couponSelected: {},
      allCoupons: "",
      afterDiscountAmt: 0,
      discountRs: 0,
      withoutDiscount: {},
      centerDialogVisible: false,
      currencySymbol: "",
      // withGst: 0,
      valueIds: [],
      gstNumber: "",
      gstCalVal: 0,
    };
  },
  watch: {
    itemstotal(val2) {
      if (val2.length) {
        if (this.currencySymbol === "S$") {
          this.activeName = "1";
        } else {
          this.activeName = "";
        }
      }
    },
  },
  methods: {
    async SGMailTriggregd() {
      let payload = {
        names: "Studio",
        projectName: this.selectedProject.projectName,
        collectionData: this.itemstotal.name,
      };
      let { data } = this.$store.dispatch("Extensions/mailTriggred", payload);
      if (data) {
        this.$swal({
          text: "Successfully Mail Send",
          icon: "success",

          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
      }
    },
    async orderConfirm() {
      let studioIds = [];
      this.itemstotal.forEach((element) => {
        studioIds.push(element._id);
      });

      // try {
      //   if (this.itemstotal.length === 0) {
      //     this.centerDialogVisible = true;
      // const order_data = await this.$store.dispatch("studio/createOrder", {
      //   userId: this.login._id,
      //   projectId: this.selectedProject._id,
      //   projectName: this.selectedProject.projectName,
      //   amount: 1,
      //   studioId: studioIds,
      //   currency: "INR",
      // });
      // for (let i = 0; i < this.itemstotal.length; i++) {
      //   const req_data = await this.$store.dispatch(
      //     "studio/createRequest",
      //     {
      //       projectName: this.selectedProject.projectName,
      //       serviceId: this.itemstotal[i]._id,
      //       projectId: this.selectedProject._id,
      //       orderId: this.createorder._id,
      //     }
      //   );
      // }
      // await this.$router.push({ name: "orderConfirm" });
      // } else {
      //   this.$swal({
      //     title: "Confirm order, proceed to payment?",
      //     type: "Warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Yes, Confirm",
      //     cancelButtonText: "No, Cancel order",
      //     showCloseButton: true,
      //     showLoaderOnConfirm: true,
      //   }).then((result) => {
      //     if (result.value) {
      this.orderfunc(studioIds);
      //       }
      //     });
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    },
    async orderfunc(studioIds) {
      // if (this.couponSelected) {
      //   const payloadData = {
      //     usedCoupons: this.couponSelected,
      //   };
      //   console.log(payloadData, "payloadData");
      //   // const payloadData = {
      //   //   _id: this.couponSelected._id,
      //   //   usageLimit: --this.couponSelected.perUserLimit,
      //   // };
      //   // console.log(payloadData, "payloadData");
      //   // const couponData = await this.$store.dispatch(
      //   //   "studio/editCoupon",
      //   //   payloadData
      //   // );
      //   // console.log(couponData, "couponData");
      //   let edit_data = await this.$store.dispatch(
      //     "studio/editLoggedUser",
      //     {
      //       _id: this.login._id,
      //     },
      //     payloadData
      //   );
      //   console.log(edit_data, "edit_data");
      // }

      console.log(studioIds, "id");
      this.valueIds = studioIds;
      const order_data = await this.$store.dispatch("studio/createOrder", {
        userId: this.login._id,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        amount: this.isCouponSelected
          ? this.afterDiscountAmt
          : this.calculation.total,
        studioId: this.valueIds,
        currency: "INR",
        orderType: "Services",
      });

      const options = {
        key: process.env.VUE_APP_RAZORPAY_KEY,
        // amount:this.selectedPlan.
        currency: "INR",
        // descriptiopn:""
        order_id: this.createorder.orderId,
        prefill: {
          name: this.login.name,
          email: this.login.email,
          contact: this.login.mobile,
        },
        handler: async (response) => {
          this.successResponse();
        },
      };
      const rzp = await new Razorpay(options);
      rzp.open();
    },
    async successResponse() {
      for (let i = 0; i < this.itemstotal.length; i++) {
        if (this.itemstotal[i].category === "Custom") {
          const req_data = await this.$store.dispatch("studio/createRequest", {
            projectName: this.selectedProject.projectName,
            serviceId: this.itemstotal[i]._id,
            projectId: this.selectedProject._id,
            orderId: this.createorder._id,
            quantity: this.itemstotal[i].quantity,
            // studioName is for email purpose only
            studioName: this.itemstotal[i].name,
            isDeducted: this.itemstotal[i].isDeducted,
            CreationType: "Admin",
          });
        } else {
          const req_data = await this.$store.dispatch("studio/createRequest", {
            projectName: this.selectedProject.projectName,
            serviceId: this.itemstotal[i]._id,
            projectId: this.selectedProject._id,
            orderId: this.createorder._id,
            quantity: this.itemstotal[i].quantity,
            studioName: this.itemstotal[i].name,
            isDeducted: this.itemstotal[i].isDeducted,
            CreationType: "Admin",
          });
        }
      }
      await this.$router.push({ name: "orderConfirm" });
      this.removeAll();
      console.log(this.couponSelected, "coupon");
      if (this.couponSelected) {
        const couponpayload = {
          projectId: this.selectedProject._id,
          couponUsed: this.couponSelected,
        };
        await this.$store.dispatch("user/updateProject", couponpayload);
        await this.$store.dispatch("user/getProject", {
          projectId: this.selectedProject._id,
        });
        await this.filterUsedCoupon();
      }
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;

      return value ? `${image_base_url}/${value}` : default_image;
    },
    async getCoupons() {
      let coupon_data = await this.$store.dispatch("studio/getCoupons", {
        isExpired: true,
      });
    },
    async selectedCoupon(value) {
      this.isCouponSelected = true;
      this.isApplied = true;
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.couponSelected = value;
      // let { data } = await this.$store.dispatch("studio/submitCoupon", {
      //   couponCode: this.couponSelected.couponCode,
      //   totalPrice: this.calculation.total,
      // });
      // console.log(data, "this");
      // this.discountRs = data.discountPrice;
      // this.afterDiscountAmt = data.finalPrice;
    },

    removeCoupon() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      // let price = this.withoutDiscount.beforePrice;
      // let gst = price * 0.18;
      // price = price + gst;
      // this.withGst = price;
      // console.log(this.withGst, "this.withGst");
    },
    removeAll() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.calculation.total = 0;
      this.itemstotal = [];
    },
    filterUsedCoupon() {
      this.allCoupons = this.getcoupons;
      for (let i = 0; i < this.selectedProject.couponUsed.length; i++) {
        for (let j = 0; j < this.allCoupons.length; j++) {
          if (
            this.selectedProject.couponUsed[i]._id == this.allCoupons[j]._id
          ) {
            this.allCoupons[j].usage = "Used";
          }
        }
      }
      console.log(this.allCoupons, "all coupons");
      console.log(this.selectedProject.couponUsed, "dbcoupon");
    },
  },
  async mounted() {
    await this.getCoupons();
    await this.filterUsedCoupon();
    this.gstNumber = this.cardoptions[0].gstNumber;
    this.currencySymbol = this.cardoptions[0].currency;
  },
  computed: {
    ...mapState("studio", [
      "itemstotal",
      "createorder",
      "getcoupons",
      "cardoptions",
    ]),
    ...mapState("admin", ["login"]),
    ...mapState("user", ["selectedProject"]),

    calculation() {
      let total = 0;
      let amt = [];
      for (var i = 0; i < this.itemstotal.length; i++) {
        if (this.itemstotal[i].price === "Free") {
          amt.push(0);
        } else {
          amt.push(
            parseInt(this.itemstotal[i].price * this.itemstotal[i].quantity)
          );
        }
      }

      // let total = 0;
      for (i = 0; i < amt.length; i++) {
        total = total + amt[i];
      }
      console.log(total, "TotalNumber");
      let gstVal = this.gstNumber / 100;

      let gst = total * gstVal;
      total = total + gst;
      if (this.isCouponSelected) {
        new Promise(async (resolve, reject) => {
          try {
            let { data } = await this.$store.dispatch("studio/submitCoupon", {
              couponCode: this.couponSelected.couponCode,
              totalPrice: total,
            });
            console.log(data, "total");
            if (data) {
              total = data.finalPrice;
              this.discountRs = data.discountPrice;
              this.afterDiscountAmt = data.finalPrice;
            }
            // resolve(data);
          } catch (error) {
            reject(error);
          }
        });
      }
      // if (this.afterDiscountAmt > 0) {
      //   total = this.afterDiscountAmt;
      // }

      return { gst: gst, total: total, beforeTotal: total };
    },
  },
  // watch: {
  //   async itemstotal() {
  //     if (Object.entries(this.itemstotal).length) {
  //       this.removeCoupon();
  //     }
  //   },
  // },
};
</script>
<style>
.ss .el-dialog--center .el-dialog__body {
  padding-bottom: 0px;
}

.ss .el-dialog__header {
  background-color: white !important;
}

.el-dialog__headerbtn .el-dialog__close {
  color: black !important;
}
.h-w-150px {
  width: 150px;
  height: 150px;
}

.ss .el-button--primary {
  background-color: #ce22b7 !important;
  border-color: #ce22b7;
  color: #fff;
}

.ss .el-button {
  background-color: gray;
  color: #fff;
}

.ss .el-dialog__footer {
  margin-top: 1rem;
}
</style>
